import { Vertex2 } from '@rta/rta-blueprint-library';

import { type SvgPolygonOptions, type Vector } from '@r-core/types';

export const svgPolygonFromVectors = (vectors: Array<Vector<Vertex2>>, polyOptions: SvgPolygonOptions): React.ReactElement => {
	const polyPoints: Array<string> = [];
	if (vectors.length > 0) {
		polyPoints.push(`${vectors[0].from.x}`);
		polyPoints.push(`${vectors[0].from.y}`);
	}

	for (let v = 0; v < vectors.length - 1; v++) {
		const vector = vectors[v];
		polyPoints.push(`${vector.to.x}, ${vector.to.y}`);
	}

	// for (const vector of vectors) {
	// 	polyPoints.push(`${vector.from.x}, ${vector.from.y}`);
	// }

	const points = polyPoints.join('\n');
	// console.log('drawSvgPolygonFromVectors', points);

	const { key } = polyOptions;
	if (polyOptions.key) delete polyOptions.key;

	// debugging showing the first line and left point
	// return <g key={key}>
	// 	<rect x={vectors[0].from.x} y={vectors[0].from.y} width={vectors[1].from.x - vectors[0].from.x} height={0.25} fill="red" />
	// 	<circle cx={vectors[0].from.x} cy={vectors[0].from.y} r={0.25} fill="blue" />
	// 	<polygon points={points} { ...polyOptions } />
	// 	</g>;

	return <polygon
		key={key}
		// onMouseOver={(e) => {
		// 	(e.target as SVGAElement).setAttribute('fill', 'yellow');
		// 	console.log('polyVector:onMouseOver', e.target, polyOptions);
		// }}
		// onMouseLeave={(e) => {
		// 	(e.target as SVGAElement).setAttribute('fill', 'white');
		// 	console.log('polyVector:onMouseLeave', e.target, polyOptions);
		// }}
		points={points} { ...polyOptions } />;
};
